const deps = [require('ui/web/documentCard').name];

module.exports = angular
  .module('bench.app.dms.addons.all', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.addons.all', {
      url: '/:date/addons/all/:page',
      params: {
        date: {
          value: 'all',
          squash: true,
        },
        page: {
          value: '1',
          squash: true,
        },
      },
      controller($stateParams) {
        this.$stateParams = $stateParams;
        return this;
      },
      controllerAs: 'vm',
      template: `\
<bl-document-card
  month="vm.$stateParams.month"
  date="vm.$stateParams.date"
  client-id="vm.$stateParams.clientId"
  document-type="ADD_ON"
  page="vm.$stateParams.page">
</bl-document-card>\
`,
    }),
  );
